import { AppVersion, RenderMode, RenderStrategy } from "../types/enums";
import { assets3D } from "../assetsLTM";
import { assets2D } from "../assetsDSM";
import { ThemeConfig } from "../types/theme";

interface AppConfigInterface {
    version: AppVersion;
    renderMode: RenderMode;
    renderStrategy: RenderStrategy;
    devMode: boolean;
    assets: {
        [AppVersion.LTM]: typeof assets3D;
        [AppVersion.DSM]: typeof assets2D;
    };
    mindFiles: {
        [AppVersion.LTM]: string;
        [AppVersion.DSM]: string;
    };
    theme: {
        [AppVersion.LTM]: ThemeConfig;
        [AppVersion.DSM]: ThemeConfig;
    };
}

export const AppConfig: AppConfigInterface = {
    version: AppVersion.DSM,  // Default version
    renderMode: RenderMode.MODE_2D,  // Default mode for DSM
    renderStrategy: RenderStrategy.STATIC,  // Default strategy
    devMode: false,  // Development mode flag
    assets: {
        [AppVersion.LTM]: assets3D,
        [AppVersion.DSM]: assets2D,
    },
    mindFiles: { 
        [AppVersion.LTM]: '/targetsLTM.mind',
        [AppVersion.DSM]: '/targetsDSM.mind',
    },
    theme: {
        [AppVersion.LTM]: {
            backgroundColor: '#A100FF',// purple 
            primaryColor: '#ffffff',    // white
            fontColor: '#000000',    // black
        },
        [AppVersion.DSM]: {
            backgroundColor: '#9138b0',
            primaryColor: '#D9B0EA',
            fontColor: '#ffffff',
        }
    }
};